import{css}from'glamor';export default css({fontSize:'1rem',fontWeight:500,lineHeight:1.125,marginBottom:4});